import { TRootState } from 'Redux/Reducers';

export const getEventCategoryCount = (state: TRootState) => state.eventCategory.maxCount;
